import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NavigationBar from './components/Navbar';
import HomePage from './components/HomePage';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import ServicesPage from './components/ServicesPage';
import Careers from './components/CareerPage';
import Courses from './components/Courses';
import ErrorBoundary from './components/ErrorBoundary';
import AdminDashboard from './components/AdminDashboard';
import CreateJob from './components/CreateJob';
import CreateJob2 from './components/admin/CreateJob';
import AllJobs from './components/AllJobs';
import JobDetails from './components/JobDetails';
import Careers2 from './components/Careers2';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ChatbotPage from './pages/ChatbotPage';
import Signup from './pages/Signup';
import PrivacyPolicy from './components/PrivacyPolicy';




const PrivateRoute = ({ element: Component, ...rest }) => {
  const { currentUser } = useAuth();
  return currentUser ? <Component {...rest} /> : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <NavigationBar />
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admindash" element={<PrivateRoute element={AdminDashboard} />} />
            <Route path="/admin/create-job" element={<PrivateRoute element={CreateJob} />} />
            <Route path="/admin/create-job2" element={<PrivateRoute element={CreateJob2} />} />
            <Route path="/admin/all-jobs" element={<PrivateRoute element={AllJobs} />} />
            <Route path="/jobs/:id" element={<JobDetails />} />
            <Route path="/careers2" element={<PrivateRoute element={Careers2} />} />
            <Route path="/chatbot" element={<ChatbotPage />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </ErrorBoundary>
        <Footer />
      </AuthProvider>
    </Router>
  );
};

export default App;
